import type React from 'react';

import { createBrowserRouter, RouterProvider, type RouteObject } from 'react-router';

import PageNotFound from '@helsenorge/core-framework/page-not-found';
import { getPath } from '@helsenorge/framework-utils/hn-page';

import { EntryPageContainer } from './components/container/entry-page-container';
import { VerktoyDetailsContainer } from './components/container/verktoydetails-container';
import { VerktoyListContainer } from './components/container/verktoylist-container';
import UthoppLandingPage from './components/uthopp/uthopp-landing-page';

// eslint-disable-next-line react-refresh/only-export-components
export const routeObject: RouteObject[] = [
  {
    path: '/',
    element: <EntryPageContainer />,
  },
  {
    path: '/finn-verktoy/:verktoyId?',
    element: <VerktoyListContainer />,
  },
  {
    path: '/uthopp/:verktoyId/:laeringsaktivitetGuid',
    element: <UthoppLandingPage />,
  },
  {
    path: '/:verktoyId',
    element: <VerktoyDetailsContainer />,
  },
  {
    path: '*',
    element: <PageNotFound />,
  },
];

// eslint-disable-next-line react-refresh/only-export-components
export const router = createBrowserRouter(routeObject, { basename: `/${getPath()}` });

export const RouterWrapper = (): React.JSX.Element => {
  return <RouterProvider router={router} />;
};
